import apiClient from './api';

// Servizio autenticazione
export default {
  // Login
  async login(email, password) {
    const response = await apiClient.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  // Ottieni informazioni utente corrente
  async me() {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  // Logout
  async logout() {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  },

  // Registrazione (se necessario)
  async register(userData) {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },
};
